import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { RscuCalc } from "../components/RscuCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.rscu_tool_name()}
        toolPath="/rscu"
      />
      <SciHeader title={m.rscu_h1()} intro={m.rscu_intro()} />

      <RscuCalc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.rscu_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.rscu_ex1(), m.rscu_ex2(), m.rscu_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.rscu_faq_q1(), a: m.rscu_faq_a1() },
          { q: m.rscu_faq_q2(), a: m.rscu_faq_a2() },
          { q: m.rscu_faq_q3(), a: m.rscu_faq_a3() },
          { q: m.rscu_faq_q4(), a: m.rscu_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
